import React, { useState, useCallback, useEffect } from 'react'
import { Input, Button, Dialog, Toast } from 'antd-mobile'
import { useNavigate } from "react-router-dom";
import * as api from '../../services/api';
import { setAuth } from '../../modules/auth';
import './login.css';

function Login() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const login = useCallback(async (username, realPassword) => {
    // 发起登录请求
    try {
      const msg = await api.login({
        username,
        realPassword,
      });
      setLoading(false)
      // console.log('登录', msg)
      if (msg.data.code === 200) {
        setAuth(msg.data.result);
        Toast.show({
          content: '登录成功！',
          position: 'top',
        })
        const loginTime = new Date().getTime();
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('loginTime', loginTime.toString());
        setTimeout(() => {
          navigate('/patientList', { replace: true })
        }, 0);
      } else {
        Dialog.show({
          content: <div className='Login_errorTip'>
            {msg.data.message}
          </div>,
          closeOnAction: true,
          actions: [
            [
              {
                key: 'cancel',
                text: <div className='Login_action'>重新输入</div>,
              },
            ],
          ],
        })
        return
      }
    } catch (error) {
      console.log(error);
      Toast.show({
        content: '登录失败，请重试！',
        position: 'top',
      })
      setLoading(false)
    }
  }, []);
  const onsubmit = async () => {
    setLoading(true)
    // 先判断机构是否可用
    try {
      const msg = await api.departIsUse({
        username: phone,
      });
      // console.log('msg', msg)
      if (msg.data.code === 200 && msg.data.result === 1) {
        login(phone, password)  // 调用登录接口
      } else {
        Toast.show({
          content: '机构不可用，请联系系统管理员',
          position: 'top',
        })
        setLoading(false)
      }
    } catch (error) {
      console.log(error);
      Toast.show({
        content: '登录失败，请重试！',
        position: 'top',
      })
      setLoading(false)
    }
  }
  const [visible, setVisible] = useState(false)

  const [redirectToList, setRedirectToList] = useState(false);
  useEffect(() => {
    // 判断登录是否过期
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const loginTime = parseInt(localStorage.getItem('loginTime'), 10);
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - loginTime;

    // 设置特定时间为1小时（3600000毫秒）
    // const validTime = 3600000;
    const validTime = 24 * 60 * 60 * 1000;

    if (isLoggedIn === 'true' && timeDifference <= validTime) {
      // 用户已登录且在特定时间内，允许访问列表页
      console.log('用户已登录且在特定时间内')
      setRedirectToList(true);
    } else {
      // 用户未登录或登录已过期，跳转到登录页
      console.log('用户未登录或登录已过期')
      setRedirectToList(false);
    }
  }, []);

  useEffect(() => {
    if (redirectToList) {
      navigate('/patientList', { replace: true })
    }
  }, [redirectToList])

  return (
    <div className='Login'>
      <div className='Login_title'>登录您的账号</div>
      <Input
        className='Login_input'
        style={{ padding: '0 16px' }}
        placeholder='输入您的手机号'
        clearable
        value={phone}
        onChange={val => {
          setPhone(val)
        }}
      />
      <div className='Login_password' style={{ padding: '0 16px' }}>
        <Input
          className='input'
          placeholder='输入您的密码'
          type={visible ? 'text' : 'password'}
          // type='password'
          // clearable
          value={password}
          onChange={val => {
            setPassword(val)
          }}
        />
        <div className='eye'>
          {!visible ? (
            <img
              src="./images/eyesIcon1.png"
              alt=""
              onClick={() => setVisible(true)}
            />
          ) : (
            <img
              src="./images/eyesIcon2.png"
              alt=""
              onClick={() => setVisible(false)}
            />
          )}
        </div>
      </div>
      <Button
        className='Login_btn'
        block
        loading={loading}
        disabled={(phone !== '' && password !== '') ? false : true}
        onClick={onsubmit}
      >
        登录
      </Button>
    </div>
  );
}

export default Login;
